
export default function CallToAction() {
  const registrationUrl = 'https://cobbfootball.leagueapps.com/clubteams/4926021-2026-cherokee-youth-football--cheerleading';

  return (
    <section id="register" className="py-20 bg-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-0 rounded-3xl overflow-hidden shadow-2xl">
          {/* Left Panel - Visual */}
          <div className="relative bg-red-50 p-12 lg:p-16 flex items-end min-h-[600px]">
            <div className="absolute inset-0">
              <img
                src="https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/ddb7ec61a5882b33f33346b86592cb16.jpeg"
                alt="Team Celebration"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            </div>

            <div className="relative z-10 space-y-2 text-center lg:text-left">
              <p className="font-sans text-sm font-semibold text-gray-200 tracking-wide">JOIN US</p>
              <h2 className="font-display text-6xl sm:text-7xl lg:text-8xl text-white leading-none">
                <span className="block">REGISTER</span>
                <span className="block text-7xl sm:text-8xl lg:text-9xl">FOR FALL</span>
                <span className="block text-8xl sm:text-9xl lg:text-[10rem]">2026</span>
              </h2>
            </div>
          </div>

          {/* Right Panel - CTA */}
          <div className="bg-white p-6 sm:p-10 lg:p-16 flex flex-col justify-center">
            <div className="w-full max-w-md mx-auto text-center space-y-8">
              <div className="space-y-4">
                <div className="w-20 h-20 flex items-center justify-center mx-auto">
                  <img
                    src="https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/3a284c370a15b2f5c58dd5f7c0a663aa.png"
                    alt="Cherokee Warriors Logo"
                    className="w-full h-full object-contain"
                  />
                </div>
                <h3 className="font-display text-3xl sm:text-4xl text-warrior-black">
                  Ready to Join the Warriors?
                </h3>
                <p className="font-sans text-sm sm:text-base text-gray-600 leading-relaxed">
                  Registration for the 2026 Fall season is now open! Click below to sign up your child for Cherokee Youth Football &amp; Cheer through our official registration portal.
                </p>
              </div>

              <div className="space-y-4">
                <div className="bg-warrior-gray rounded-2xl p-5 sm:p-6 text-left space-y-3">
                  <h4 className="font-display text-lg text-warrior-black">What's Included</h4>
                  <ul className="space-y-2">
                    {[
                      'Football & Cheer programs for grades K–5',
                      'Games held in high school football stadiums',
                      'All equipment and uniform provided',
                      'Experienced coaches and staff',
                      'Full season of games and events',
                    ].map((item) => (
                      <li key={item} className="flex items-start space-x-2 font-sans text-sm text-gray-700">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-checkbox-circle-fill text-warrior-red text-base"></i>
                        </div>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <a
                  href={registrationUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-warrior-red text-white font-sans font-bold text-sm sm:text-base px-6 py-4 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center space-x-2"
                >
                  <span>REGISTER NOW</span>
                  <i className="ri-external-link-line text-xl"></i>
                </a>

                <a
                  href="https://form.jotform.com/253468410435052"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full border-2 border-warrior-black text-warrior-black font-sans font-bold text-xs sm:text-sm px-4 py-4 rounded-lg hover:bg-warrior-black hover:text-white transition-colors cursor-pointer flex items-center justify-center space-x-2"
                >
                  <i className="ri-mail-line text-lg sm:text-xl"></i>
                  <span>SUBSCRIBE FOR EMAIL UPDATES</span>
                </a>

                <p className="font-sans text-xs text-gray-500">
                  You'll be taken to our official registration portal on LeagueApps to complete sign-up.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
